import { PageDetailsTabs } from "../../context/types";
import { FC } from "react";
import General from "./Content/General";
import Translations from "./Content/Translations";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { usePageDetails } from "../../context";

export const useTabsContent = () => {
  const { selectedTab } = usePageDetails();

  const TAB_CONTENT: Record<PageDetailsTabs, FC> = {
    [PageDetailsTabs.General]: General,
    [PageDetailsTabs.Translations]: Translations,
  };
  return TAB_CONTENT[selectedTab];
};

export const useTabsAccess = () => {
  const { allowed: hasReadAccess } = useRolePermission("brandsAndPages:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission("brandsAndPages:translations:read");

  return {
    shouldRenderGeneralTab: hasReadAccess,
    shouldRenderTranslationsTab: hasReadAccess || hasReadTranslationsAccess,
  };
};